import { apiCall } from 'services/api';
import { getLoaders } from 'entities/_config';

import { AppStatus } from './types';

export const infraLoaders = getLoaders({
  appStatus: {
    load: async ({ version }: { version: string }): Promise<AppStatus> => {
      return apiCall({
        path: '/infra/web/status',
        method: 'get',
        auth: false,
        payload: {
          version,
        },
      });
    },
  },
});
